import { render, staticRenderFns } from "./ModalAddEmrTemplate.vue?vue&type=template&id=39589d75&scoped=true"
import script from "./ModalAddEmrTemplate.vue?vue&type=script&lang=js"
export * from "./ModalAddEmrTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39589d75",
  null
  
)

export default component.exports